import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { actionCreators } from '../../store/NonLinear/PublicationStore';
import { LoadingBar } from '../Controls/LoadingBar';
import ModalDialogError from "../Controls/ModalDialogError";
import { SVMDatePicker } from "../Controls/SVMDatePicker";
import { isStringNullOrWhiteSpace } from '../../tools/validator';
import { getMandatoryBgCss, stringToMoment, toDate } from '../../tools/toolkit';
import { ExpireDateCompareWithPublishedDate, PublicationMandatoryFieldsMustBeEntered } from '../../messages/businessMessages';
import ModalDialogWarning from '../Controls/ModalDialogWarning';
//import $ from 'jquery';

class Publication extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeElement: ''
        };
    }

    handleErrorDialogClose = () => {
        this.props.clearErrorMessage();
    }

    handleCancel = (event) => {
        this.props.onValidationError([]);
        this.props.newPublication(this.props.programmeId);

        this.setState({ activeElement: 'cancelButton' });
    }

    handleSave = (event) => {
        event.preventDefault();

        const data = {
            id: this.refs.id.value,
            identifier: this.refs.identifier.value,
            platform: { id: this.refs.platformId.value },
            published: this.refs.published.state.startDate,
            expiry: this.refs.expiry.state.startDate
        };

        if (!this.validateForm(data)) {
            return false;
        }

        data.published = toDate(data.published).toDateString();
        data.expiry = toDate(data.expiry) ? toDate(data.expiry).toDateString() : undefined;

        this.props.createPublication(this.props.programmeId, data);

        this.setState({ activeElement: 'saveButton' });
    }

    handleKeyDown = function (e) {
        if (e.key === 'Enter' && e.shiftKey === false) {
            if (document.activeElement === this.refs.cancelButton) {
                e.preventDefault();
                this.refs.cancelButton.click();
            }
            else if (document.activeElement === this.refs.saveButton) {
                e.preventDefault();
                this.refs.saveButton.click();
            }
            else if (document.activeElement.type !== 'a') {
                e.preventDefault();
                return false;
            }
            else
                return true;
        }
    };

    validateForm(data) {
        let messages = [];
        let valid = true;

        this.refs.identifier.classList.remove('mandatoryBg');
        this.refs.platformId.classList.remove('mandatoryBg');
        this.refs.published.removeClassName('mandatoryBg');
        this.refs.expiry.removeClassName('mandatoryBg');

        if (isStringNullOrWhiteSpace(data.identifier)) {
            this.refs.identifier.classList.add('mandatoryBg');
            messages.push({ controlId: 'identifier', message: 'Publication Identifier is missing. Please enter an identifier first.' });
            valid = false;
        }

        if (isStringNullOrWhiteSpace(data.platform.id)) {
            this.refs.platformId.classList.add('mandatoryBg');
            messages.push({ controlId: 'platform', message: 'Platform is missing. Please select a platform first.' });
            valid = false;
        }

        if (isStringNullOrWhiteSpace(data.published)) {
            this.refs.published.addClassName('mandatoryBg');
            messages.push({ controlId: 'publishedDate', message: 'Published Date is missing. Please enter a date first.' });
            valid = false;
        }

        var dateformat = /^\d{2}\/\d{2}\/\d{4}$/;

        if (!isStringNullOrWhiteSpace(data.published) && !data.published.match(dateformat)) {
            this.refs.published.addClassName('mandatoryBg');
            messages.push({ controlId: 'publishedDate', message: 'Published Date is invalid. Please enter a valid date first.' });
            valid = false;
        }

        if (!isStringNullOrWhiteSpace(data.expiry) && !data.expiry.match(dateformat)) {
            this.refs.expiry.addClassName('mandatoryBg');
            messages.push({ controlId: 'expiryDate', message: 'Expiry Date is invalid. Please enter a valid date first.' });
            valid = false;
        }

        if (valid && !isStringNullOrWhiteSpace(data.expiry) && stringToMoment(data.expiry) < stringToMoment(data.published)) {
            //$("#invalidExpiryDateMD").modal();
            this.refs.expiry.addClassName('mandatoryBg');
            messages.push({ controlId: 'expiryDate', message: ExpireDateCompareWithPublishedDate });
            valid = false;
        }

        if (!this.props.isLoading) {
            this.props.onValidationError(messages);
        }
        return valid;
    }

    componentDidUpdate() {
        if (this.state.activeElement !== '') {
            switch (this.state.activeElement) {
                case 'saveButton': if (this.refs.saveButton) { this.setState({ activeElement: '' }); this.refs.saveButton.focus(); } break;
                case 'cancelButton': if (this.refs.cancelButton) { this.setState({ activeElement: '' }); this.refs.cancelButton.focus(); } break;
            }
        }
    }

    renderCreateForm() {
        if (this.props.data) {
            return (
                <form onKeyDown={(e) => { this.handleKeyDown(e); }}>
                    <table style={{ display: 'block' }} summary='Enter the publication identifier, platform and published date. These are mandatory fields. Enter the expiry date if required. This is an optional field. Click the add link to add the publication. Once added, you can provide further publication information in the content rights and programme category sections.'>
                        <div className='container-fluid'>
                            <div className='row pt-1'>
                                <input type="hidden" name="id" value={this.props.data.id} ref='id' />
                                <div className='col-md-7 pt-1 pl-0'>
                                    <label className='form-text font-weight-bold '>Publication Identifier <span className='mandatory' aria-hidden='true'>*</span> <small id='contentIdentifierHelp'>(max. 2000 char.)</small></label>
                                </div>
                                <div className='col-md-2 pt-1 pl-0'>
                                    <label htmlFor='platform' className='form-text font-weight-bold'>Platform<span className='mandatory' aria-hidden='true'> *</span></label>
                                </div>
                                <div className='col-md-1 pt-1 pl-0'>
                                    <label className='form-text font-weight-bold'>Published Date<span className='mandatory' aria-hidden='true'> *</span></label>
                                </div>
                                <div className='col-md-1 pt-1 pl-0'>
                                    <label className='form-text font-weight-bold'>Expiry Date</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-7 pl-0'>
                                    <input id='identifier' name='identifier' ref='identifier' className={'w-100 ' + getMandatoryBgCss(this.props.validationResult, 'publication', 'publicationlog')} type='text' maxLength={2000} defaultValue={this.props.data.identifier} aria-required='true' aria-label='Add publication, publication identifier, maximum of 2000 characters' />
                                </div>
                                <div className='col-md-2 pl-0'>
                                    <select id='platform' name='platformId' ref='platformId' className={'dropDownDefaults ' + getMandatoryBgCss(this.props.validationResult, 'publication', 'publicationlog')} defaultValue={this.props.data.platform.id} aria-required='true' aria-label='Add publication, platform'>
                                        <option value="">Select Platform</option>
                                        {this.renderPlatforms()}
                                    </select>
                                </div>
                                <div className='col-md-1 pl-0'>
                                    <SVMDatePicker
                                        id='publishedDate'
                                        name='published'
                                        ref='published'
                                        className={'w-100 ' + getMandatoryBgCss(this.props.validationResult, 'publication', 'publicationlog')}
                                        value={this.props.data.published}
                                        canEdit='true'
                                        dateWarningMessage='Published Date'
                                        ariaLabel='Add publication, published date'
                                        ariaRequired='true'
                                        onValidationError={(messages) => this.props.onValidationError(messages)} />
                                </div>
                                <div className='col-md-1 pl-0'>
                                    <SVMDatePicker
                                        id='expiryDate'
                                        name='expiry'
                                        ref='expiry'
                                        className='w-100'
                                        value={this.props.data.expiry}
                                        minDate={this.props.data.published}
                                        minDateInputName='published'
                                        canEdit='true'
                                        dateWarningMessage='Expiry Date'
                                        minDateWarningMessage={ExpireDateCompareWithPublishedDate}
                                        ariaLabel='Add publication, expiry date'
                                        onValidationError={(messages) => this.props.onValidationError(messages)} />
                                </div>
                                <div className='col-md-1 pl-0 pr-0'>
                                    <div className='float-right'>
                                        <a id='cancelButton' ref='cancelButton' className='btn btn-link link' tabIndex='0' aria-label='Cancel adding new publication' onClick={this.handleCancel}>Cancel</a> | <a id='saveButton' ref='saveButton' className='btn btn-link link' aria-label='Add a new publication' tabIndex='0' onClick={this.handleSave}>Add</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </table>
                </form>
            );
        }

        return '';
    }

    renderPlatforms() {

        if (this.props.platforms) {
            return (
                this.props.platforms.map(item =>
                    <option key={item.id} value={item.id}>{item.name}</option>
                )
            );
        }

        return '';
    }

    render() {
        return (
            <div className='addPanel addPublicationPanel'>
                {(this.props.isLoading ? '' : this.renderCreateForm())}
                <ModalDialogError id='errorModalDialog' errorData={this.props.errorData} onCloseClick={this.handleErrorDialogClose} hasErrorOccured={this.props.hasErrorOccured} />
                <ModalDialogWarning id='invalidExpiryDateMD' message={ExpireDateCompareWithPublishedDate} className='w-75' />
                <ModalDialogWarning id='publicationValidationMD' message={PublicationMandatoryFieldsMustBeEntered} className='w-75' />
                <LoadingBar isLoading={this.props.isLoading} />
            </div>
        );
    }
}

export default connect(
    state => state.publication,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Publication);


// WEBPACK FOOTER //
// ./src/components/NonLinear/Publication.js